import * as caseUploadTypes from './caseUploadTypes';

const initialState = {
  downloadCaseTempSuccess: false,
  downloadCaseTempPending: false,
  tableData: [],
  filters: {},
  showFilterModal: false,
  documents: [],
  importJobId: 0,
  caseUploadPending: false,
  isUploadError: false,
};

const caseUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case caseUploadTypes.DOWNLOAD_CASE_TEMPLATE_PENDING:
      return {
        ...state,
        downloadCaseTempSuccess: false,
        downloadCaseTempPending: true,
      };
    case caseUploadTypes.DOWNLOAD_CASE_TEMPLATE_SUCCESS:
      return {
        ...state,
        downloadCaseTempSuccess: action.payload.response.success,
        downloadCaseTempPending: false,
      };
    case caseUploadTypes.DOWNLOAD_CASE_TEMPLATE_FAILURE:
      return {
        ...state,
        downloadCaseTempSuccess: false,
        downloadCaseTempPending: false,
      };
    case caseUploadTypes.GET_UPLOADED_CASES_SUCCESS:
      return { ...state, tableData: action.payload };
    case caseUploadTypes.GET_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };
    case caseUploadTypes.SET_IMPORT_JOB_ID:
      return {
        ...state,
        importJobId: action.data.jobId,
        caseUploadPending: false,
        isUploadError: false,
      };
    case caseUploadTypes.RESET_CASE_UPLOAD:
      return {
        ...state,
        documents: [],
        importJobId: 0,
        isUploadError: false,
      };
    case caseUploadTypes.CASE_UPLOAD_PENDING:
      return {
        ...state,
        caseUploadPending: true,
        isUploadError: false,
      };
    case caseUploadTypes.CASE_UPLOAD_FAILURE:
      return {
        ...state,
        caseUploadPending: false,
        isUploadError: true,
      };
    case caseUploadTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };
    default:
      return state;
  }
};

export { initialState };
export default caseUploadReducer;
